import { Component} from '@angular/core';

@Component({
    selector: 'ivrDonationDetail-main',
    templateUrl: './ivrDonationDetail-main.tmpl.html'
})

export class IvrDonationDetailMain {
    editMode: boolean = null;

    public setVal(val:boolean) {
        this.editMode = val;
    }
}
